export default {
    namespaced: true,
    state: {
        monitorStatusUpListener: null,
        monitorStatusDownListener: null,
    },
    getters: {
        monitorStatusUpListener(state) {
            return state.monitorStatusUpListener
        },
        monitorStatusDownListener(state) {
            return state.monitorStatusDownListener
        },
    },
    mutations: {
        mutateMonitorListeners(state, payload) {
            state.monitorStatusUpListener = payload.monitorStatusUpListener
            state.monitorStatusDownListener = payload.monitorStatusDownListener
        }
    },
    actions: {
        updateListeners(context, payload) {
            context.commit('mutateMonitorListeners', payload)
        }
    }
}
